import React, { memo, Fragment, useContext, useState, useEffect } from 'react'
import { Image } from 'react-bootstrap'
import { AuthContext } from '../../context/auth-context'
import { gql, useQuery } from '@apollo/client'
import Loader from '../../layouts/components/Loader'

const GET_USER = gql`
    query Users($where: UserWhere) {
        users(where: $where) {
            id
            username
            firstName
            lastName
            logoImage
        }
    }
`

const DEFAULT_PROFILE_IMAGE = 'logo-dark.png'

const SidebarProfileCard = memo(() => {
    const { user } = useContext(AuthContext)
    const { data, loading } = useQuery(GET_USER, { variables: { where: { id: user.id } } })
    const [profileImage, setProfileImage] = useState(data?.users[0]?.logoImage || DEFAULT_PROFILE_IMAGE)

    const name = () => {
        return data.users[0].firstName + ' ' + data.users[0].lastName
    }

    useEffect(() => {
        if (data?.users[0]?.logoImage) {
            setProfileImage(data.users[0].logoImage)
        }
    }, [data, setProfileImage])

    return (
        <Fragment>
            {loading ? (
                <div>
                    <Loader fullScreen={false} />
                </div>
            ) : (
                <div className="sidebar-profile-card mx-4 my-3">
                    <div className="sidebar-profile-body d-flex align-items-center">
                        <div className="sidebar-profile-avatar d-flex justify-content-center pe-3 ps-0">
                            <Image
                                src={`${process.env.REACT_APP_S3_BUCKET_URL}${profileImage ? profileImage : DEFAULT_PROFILE_IMAGE}`}
                                alt="User Logo"
                                onError={() => setProfileImage(DEFAULT_PROFILE_IMAGE)}
                                className="img-fluid rounded"
                                width={48}
                                height={48}
                            />
                        </div>
                        <div className="sidebar-profile-detail d-flex flex-column align-items-start justify-content-start mb-0">
                            <h6 className="sidebar-profile-name mb-0 text-start">{name()}</h6>
                            <span className="sidebar-profile-username small text-gray-200">{`@${data?.users[0]?.username}`}</span>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
})

export default SidebarProfileCard
